export default "../css/f0be7d273c3543fe4c4ab44c1432a0ba.ttf";